import type { ToasterProps } from 'sonner';

/**
 * The dashboard's one toast setup. Layout, the dev /design-system page and the
 * design system guide's "Dashboard toast" example all render it, so the guide
 * cannot show a toast the app does not. Layout adds its own bottom offset to
 * clear the help button.
 */
export const DASHBOARD_TOASTER_PROPS = {
  position: 'bottom-right',
  richColors: true,
  closeButton: true,
} as const satisfies ToasterProps;
